var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { staticClass: "inspections", attrs: { link: "inspections" } },
    [
      _c(
        "div",
        { attrs: { slot: "tileHeader" }, slot: "tileHeader" },
        [_c("tile-title", { attrs: { icon: "bolt" } }, [_vm._v("Проверки")])],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "tileContent" }, slot: "tileContent" },
        [
          _vm.auth
            ? _c(
                "div",
                { staticClass: "inspections__content" },
                [
                  _c(
                    "left-transition",
                    {
                      attrs: {
                        isShow:
                          _vm.years.length > 0 && _vm.contentType === "table",
                      },
                    },
                    [
                      _c(
                        "div",
                        { ref: "htmlContent" },
                        [
                          _c("inspections-table", {
                            staticClass: "inspections__table",
                            attrs: {
                              years: _vm.sorted_years,
                              data: _vm.inspections,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "right-transition",
                    {
                      attrs: {
                        isShow:
                          _vm.years.length > 0 && _vm.contentType === "chart",
                      },
                    },
                    [_c("chart")],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isModal ? _c("inspections-modal") : _vm._e(),
                ],
                1
              )
            : _c("demo-message"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "inspections__footer",
          attrs: { slot: "tileFooter" },
          slot: "tileFooter",
        },
        [
          _c(
            "app-switcher",
            {
              attrs: {
                leftClickHandler: function () {
                  return (_vm.contentType = "table")
                },
                rightClickHandler: function () {
                  return (_vm.contentType = "chart")
                },
              },
            },
            [
              _c("span", { attrs: { slot: "leftValue" }, slot: "leftValue" }, [
                _vm._v("Таблица"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { attrs: { slot: "rightValue" }, slot: "rightValue" },
                [_vm._v("График")]
              ),
            ]
          ),
          _vm._v(" "),
          _c("tilePrintPdf", {
            attrs: {
              html: _vm.htmlForPrint,
              title: _vm.title,
              printStyle: _vm.printStyle,
              filename: "inspections",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }